import React, { useContext } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import { AppContext } from '../App';


export const PaymentWalletReport = () => {
	const { getDetailReport, postCall, detailReport, getDate, getBill, setViewBillModal, payWallet, setPayWalletReport, payWalletReport, setGetLoad, getLoad } = useContext(AppContext);
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		let wallet = e.target.service.value;
		if (start !== "" && end !== "") {
			postCall('api/bnr/get/payment/wallet/report/', { start_date: start, end_date: end, staff_id: staff, wallet_id: wallet }).then(res => {
				setPayWalletReport(res.data);
				setGetLoad(false);
			}).catch(err => {
				setGetLoad(false);
			});
		}
	}
	return (
		<div className='container-fluid'>
			<div className='grid2by8 align-items-center justify-content-center p-2 bgp br-3 mb-3' >
				{
					getLoad ? (
						<div className="d-grid py-2">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						<span className='text-white' >Payment Wallet Report</span>
					)

				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									payWalletReport !== undefined ? (
										payWalletReport.users !== undefined ? (
											Object.keys(payWalletReport.users).length > 0 ? (
												Object.keys(payWalletReport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{payWalletReport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="service" className="shadow-none br-2">
								<option value="" >All Wallets</option>
								{
									payWalletReport !== undefined ? (
										payWalletReport.wallets !== undefined ? (
											Object.keys(payWalletReport.wallets).length > 0 ? (
												Object.keys(payWalletReport.wallets).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`serv_${staff_i}`} >{payWalletReport.wallets[staff].name}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={2} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>

			<Table bordered className="tbl-bg-blue" >
				<thead>
					<tr>
						<th><span className="tp2" >Invoice</span></th>
						<th><span className="tp2" >Service</span></th>
						<th className="tp2" >Staff</th>
						<th className="tp2" ><span>Customer</span></th>
						<th className="text-end tp2" ><span>Amount</span></th>
					</tr>
				</thead>
				<tbody>
					{
						payWalletReport !== undefined ? (
							payWalletReport.wallet_values !== undefined ? (
								Object.keys(payWalletReport.wallet_values).length > 0 ? (
									Object.keys(payWalletReport.wallet_values).map((b_val, b_i) => (
										<tr key={`b_val_${b_i}`} >
											<td>
												<span className="tp2 d-grid mb-1" >Invoice : {payWalletReport.wallet_values[b_val].bill_no}</span>
												<span onClick={() => {
													getBill(payWalletReport.wallet_values[b_val].bill_no);
													setViewBillModal(true);
												}} className="view-bill-link mx-0" >View bill</span>
												<span className="tp2 f14 d-grid mt-1" >{payWalletReport.wallet_values[b_val].date}, {payWalletReport.wallet_values[b_val].time}</span>
											</td>
											<td className="tp2">{payWalletReport.wallet_values[b_val].service}</td>
											<td className="tp2">{payWalletReport.wallet_values[b_val].created_by}</td>
											<td>
												<span className="tp2 d-grid mb-1" >{payWalletReport.wallet_values[b_val].customer_name}</span>
												<span className="tp2 d-grid mb-1" >{payWalletReport.wallet_values[b_val].customer_phone}</span>
											</td>
											<td className="tp2" >
												<div class="grid8by2 align-items-center" >
													<span className="tp2 f16" >{payWalletReport.wallet_values[b_val].wallet}</span>
													<div className='d-flex justify-content-end' >
														<span className="tp2 f16" >{parseFloat(payWalletReport.wallet_values[b_val].transaction_bill_total).toFixed(2)}</span>
													</div>
												</div>
											</td>
										</tr>
									))
								) : ''
							) : ''
						) : ''
					}
					{
						payWalletReport !== undefined ? (
							payWalletReport.main !== undefined ? (
								<>
									<tr>
										<td colSpan={4} ></td>
										<td className="f18 tp2" >
											{
												payWalletReport.main.wallet_total !== undefined && Object.keys(payWalletReport.main.wallet_total).length > 0 ? (
													Object.keys(payWalletReport.main.wallet_total).map((wt, wti) => (
														<div class="grid8by2 align-items-center bdrb2" key={`waaa_${wti}`} >
															<span className="tp2 f16" >{wt}</span>
															<div className='d-flex justify-content-end' >
																<span className="tp2 f16" >{parseFloat(payWalletReport.main.wallet_total[wt]).toFixed(2)}</span>
															</div>
														</div>
													))
												) : ''
											}

										</td>
									</tr>
									<tr>
										<td colSpan={4} className='bgy text-end' ><span className="f20" >Total</span></td>
										<td className='bgy text-end' ><span className="f20" >{parseFloat(payWalletReport.main.total).toFixed(2)}</span></td>
									</tr>
								</>
							) : ''
						) : ''
					}
				</tbody>
			</Table>

		</div>
	)
}